import { CRISIS_LIFELINE_HREF } from "@/constants/aptihealth";
import { Link2 } from "@/ui2/atoms/Link";

export function CrisisSupportInfo() {
  return (
    <p
      className="body-xs tw:text-text-tertiary!"
      style={{ color: "var(--brand-gray-600) !important" }}
    >
      <b
        className="tw:block"
        // reboot workaround
        style={{ color: "var(--brand-gray-600) !important" }}
      >
        Crisis Support
      </b>
      If you are in a life-threatening situation, call or text the
      <Link2 className="tw:mx-0.5ch" href={CRISIS_LIFELINE_HREF} isExternal rawChildren size="xs">
        Suicide and Crisis Lifeline
      </Link2>
      at{" "}
      <Link2 href="tel:988" rawChildren size="xs">
        988
      </Link2>
      .
    </p>
  );
}
